import React from 'react';
import {Control, UseFormRegister} from 'react-hook-form';
import {Trans} from '@lingui/react';
import {t} from '@lingui/core/macro';
import cn from 'classnames';

import DelaySelector from 'shared/ui/DelaySelector/DelaySelector';
import Problem from 'shared/ui/icons/General/Problem';
import HintQuestion from 'shared/ui/Hint/HintQuestion';
import FormGroup from 'shared/ui/FormGroup/FormGroup';
import Checkbox from 'shared/ui/Checkbox/Checkbox';
import Envelope from 'shared/ui/icons/Envelope';
import IHttpMonitorOutput from 'features/http/model/HttpMonitor/IHttpMonitor';
import {useNotifyEmail} from 'features/http/model/useNotifyEmail';
import {isTranslate} from 'shared/lib/lang';

import {PALETTE} from 'shared/config/model/palette';

import NotifyExtraEmail from '../NotifyExtraEmail/NotifyExtraEmail';

import styles from './NotifyEmail.module.scss';

interface INotifyEmailProps {
    item?: IHttpMonitorOutput,
    control: Control<any>,
    register: UseFormRegister<any>,
}

const NotifyEmail: React.FC<INotifyEmailProps> = ({item, control, register}) => {
    const {user, confirmEmail, isNotifyByEmail, checkedEmailsCount} = useNotifyEmail(control, item);
    // eslint-disable-next-line max-len
    const EMAIL_CONFIRM = t`Для отправки уведомлений о сбоях нужно подтвердить адрес почты. После подтверждения вы сможете выбрать его в настройках монитора.`;

    return (
        <div className={styles.container}>
            {
                user?.email_confirmed
                    ? (
                        <div className={styles.notifyBlock}>
                            <div className={styles.subHeader}>
                                <Envelope/>
                                <span className={styles.title}>
                                    Email {checkedEmailsCount > 0 && `(${checkedEmailsCount})`}
                                </span>
                            </div>
                            <div className={styles.selectorBlock}>
                                <FormGroup className={styles.formGroup}>
                                    <Checkbox
                                        textStyle={styles.checkbox}
                                        {...register('notify_by_email')}
                                    >
                                        {user?.email}
                                    </Checkbox>
                                </FormGroup>
                                {isNotifyByEmail && (
                                    <DelaySelector
                                        control={control}
                                        name="notify_email_confirmed_delay"
                                        value={item?.notify_email_confirmed_delay ?? 0}
                                    />
                                )}
                            </div>
                            <NotifyExtraEmail item={item} control={control} register={register}/>
                        </div>
                    )
                    : (
                        <>
                            <div className={styles.blockWhitError}>
                                <Problem color={PALETTE.error}/>
                                <span>
                                    <Trans id="text.label.extra.email" message="Необходимо подтвердить E-mail"/>:
                                </span>
                                <span className={styles.error}>{user?.email}</span>
                            </div>
                            <div className={styles.blockAction}>
                                <button
                                    onClick={confirmEmail}
                                    className={cn(
                                        styles.button,
                                        isTranslate() && styles.enColorButton,
                                    )}
                                >
                                    {t`Подтвердить`}
                                </button>
                                <HintQuestion placement="top-start">{EMAIL_CONFIRM}</HintQuestion>
                            </div>
                        </>
                    )
            }

        </div>
    );
};

export default NotifyEmail;